module.exports = __webpack_public_path__ + "img/NETA-Logo.f3719986.png";